import store from '@/store'
export default [
  {
    path: '/default-credit-days',
    name: 'default-credit-day',
    meta: { requiresAuth: true },
    component: () => import('@/pages/default-credit-day/index.vue')
  }
]
